<template>
    <div class="user-segments">
        <div style="background-color: #ffffff" class="d-flex">
            <a-card class="vh-100 w-100">
                <div class="row m-3 d-flex flex-row align-items-center justify-content-around" style="width: 48%">
                    <h3 class="col-md mt-2 segment-main-title">{{ $t("chatbotv2.userSegments") }}</h3>
                    <a-button
                        type="primary"
                        size="large"
                        class="col-md d-flex flex-row align-items-center segment-main-title"
                        @click="modalVisible = true"
                        v-if="checkPermission(PERMISSION_TYPES['chatbot.usersegments.create'].tr.name)"
                    >
                        <span class="material-icons m-0 p-0"> add </span>
                        {{ $t("chatbotv2.addSegment") }}
                    </a-button>
                </div>
                <div class="m-5" v-if="!loading">
                    <a-table
                        :key="'vtable-' + renderCount"
                        :rowKey="`_id`"
                        :columns="columns"
                        :dataSource="segments"
                        :pagination="false"
                        :customRow="
                            (record) => {
                                return {
                                    props: {},
                                    on: {
                                        mouseover: (event) => {
                                            rowMouseOver(record);
                                        },
                                        mouseleave: (event) => {
                                            rowMouseLeave(record);
                                        }, // mouse leave row
                                    },
                                };
                            }
                        "
                    >
                        <template slot="avatar" slot-scope="text, record">
                            <div
                                class="user-segment-avatar text-center"
                                :class="{ 'user-segment-avatar-odd': isRowNumberOdd(record) }"
                            >
                                <!--                                <Avatar :size="40" :username="record.name" class="mr-2" style="color: white" />-->
                                <md-highlight-text md-term="term" class="text-center">
                                    {{ record.name.slice(0, 2).toUpperCase() }}
                                </md-highlight-text>
                            </div>
                        </template>
                        <span slot="segmentNameTitle"> {{ $t("chatbotv2.segmentName") }}</span>
                        <span slot="usersTitle"> {{ $t("chatbotv2.usersInSegment") }}</span>
                        <span slot="users" slot-scope="text, record">
                            {{
                                !!record.users.length ? `${record.users.length} User` : $t("chatbotv2.noUsersAdded")
                            }}</span
                        >
                        <span
                            v-if="checkPermission(PERMISSION_TYPES['chatbot.usersegments.update'].tr.name)"
                            slot-scope="text, record"
                            class="d-flex flex-row justify-content-end operation-buttons"
                            :class="{ hidden: selectedRowId !== record._id }"
                            slot="operation"
                        >
                            <span
                                class="material-icons mx-2 text-primary operation-button"
                                @click="() => onEditSegment(record)"
                            >
                                edit
                            </span>
                            <span
                                @click="showConfirm(record)"
                                class="material-icons mx-2 text-danger operation-button"
                                v-if="checkPermission(PERMISSION_TYPES['chatbot.usersegments.delete'].tr.name)"
                            >
                                delete
                            </span>
                        </span>
                    </a-table>
                </div>
                <div v-else>
                    <a-spin></a-spin>
                </div>
            </a-card>
            <a-modal
                id="add-segment-modal"
                :title="editMode ? $t('chatbotv2.updateSegment') : $t('chatbotv2.newSegment')"
                wrapClassName="vertical-center-modal"
                v-model="modalVisible"
                @ok="modalOk()"
                @cancel="modalCancel()"
                :okText="!editMode ? $t('message.ok') : $t('message.edit')"
                :cancelText="$t('message.cancel')"
            >
                <a-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSave">
                    <a-form-item
                        :label="$t('chatbotv2.segmentName')"
                        :fieldDecoratorOptions="{
                            rules: [{ required: true, message: 'Please input name of segment' }],
                        }"
                    >
                        <a-input v-model="segment.name" />
                    </a-form-item>
                </a-form>
            </a-modal>
        </div>
    </div>
</template>

<script>
import SideMenuBar from "../../SideMenuBar";
import { mapActions, mapGetters } from "vuex";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";
import ChatbotMenu from "../../ChatbotMenu.vue";

const columns = [
    {
        dataIndex: "avatar",
        key: "avatar",
        slots: { title: "" },
        scopedSlots: { customRender: "avatar" },
        width: "5%",
    },
    {
        dataIndex: "name",
        key: "name",
        slots: { title: "segmentNameTitle" },
        scopedSlots: { customRender: "name" },
    },
    {
        dataIndex: "users",
        key: "users",
        slots: { title: "usersTitle" },
        scopedSlots: { customRender: "users" },
    },
    {
        title: "",
        dataIndex: "operation",
        key: "operation",
        slots: { title: "" },
        scopedSlots: { customRender: "operation" },
    },
];

export default {
    name: "UserSegments",
    components: { ChatbotMenu, SideMenuBar },
    data() {
        return {
            columns,
            renderCount: 0,
            segments: null,
            editMode: false,
            modalVisible: false,
            segment: [
                {
                    id: null,
                    name: "",
                    users: [],
                },
            ],
            updatedSegment: {},
            loading: false,
            submitting: false,
            itemKey: null,
            selectedRowId: null,
            queryAction: this.$route.query.action,
        };
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        userSegmentPermission() {
            return [
                PERMISSION_TYPES["chatbot.usersegments.create"].tr.name,
                PERMISSION_TYPES["chatbot.usersegments.update"].tr.name,
                PERMISSION_TYPES["chatbot.usersegments.delete"].tr.name,
            ].some((permission) => this.checkPermission(permission));
        },
    },
    methods: {
        ...mapActions({
            listSegments: "CB/listSegments",
            createNewSegment: "CB/createNewSegment",
            updateSegment: "CB/updateSegment",
            deleteSegment: "CB/deleteSegment",
            removeSegment: "CB/removeSegment",
        }),
        onEditSegment(item) {
            this.editMode = true;
            this.modalVisible = true;
            const name = item.name;
            this.segment.name = name;
            this.updatedSegment = item;
        },
        rowMouseOver(record) {
            this.selectedRowId = record._id;
        },
        rowMouseLeave(record) {
            this.selectedRowId = null;
        },
        isRowNumberOdd(record) {
            if (!!this.segments)
                return (this.segments.findIndex((segment) => segment._id === record._id) + 1) % 2 !== 0;
        },
        handleSave() {
            const isThereSameSegment = this.segments.find(
                (segment) => segment.name.toLowerCase() === this.segment.name.toLowerCase()
            );
            if (isThereSameSegment) {
                this.$toasted.error(this.$t("chatbotv2.sameSegment"), {
                    duration: 3000,
                    position: "bottom-center",
                });
                return;
            } else {
                if (!this.editMode) {
                    const name = this.segment.name;
                    const users = [];
                    this.addNewSegment({ name, users });
                } else {
                    this.updatedSegment.name = this.segment.name;
                    const { id, name, users } = this.updatedSegment;
                    this.onUpdateSegment({ id, name, users });
                }
            }
        },
        addNewSegment(payload) {
            this.editMode = false;
            this.submitting = true;
            this.createNewSegment(payload).then((res) => {
                this.renderCount += 1;
                this.segments.push(res);
                this.submitting = false;
                this.modalVisible = false;
                this.resetSegment();
            });
        },
        onUpdateSegment(payload) {
            this.submitting = true;
            this.updateSegment(payload).then((res) => {
                this.submitting = false;
                this.modalVisible = false;
                this.editMode = false;
                this.resetSegment();
            });
        },
        showConfirm(record) {
            this.$confirm({
                title: this.$t("chatbotv2.douYouWannaDeleteItem"),
                onOk: () => this.onDeleteSegment(record),
                onCancel() {},
            });
        },
        onDeleteSegment(payload) {
            this.loading = true;
            this.submitting = true;
            this.removeSegment(payload._id)
                .then(() => {
                    const tempSegment = [...this.segments];
                    this.segments = tempSegment.filter((segment) => segment._id !== payload._id);
                })
                .finally(() => {
                    this.loading = false;
                    this.submitting = false;
                });
        },
        resetSegment() {
            this.segment = [
                {
                    id: null,
                    name: "",
                    users: [],
                },
            ];
            this.editMode = false;
        },
        modalOk() {
            this.handleSave();
        },
        modalCancel() {
            this.modalVisible = false;
            this.resetSegment();
        },
    },
    mounted() {
        this.loading = true;
        this.listSegments()
            .then((res) => {
                this.segments = res;
                if (this.queryAction == "create") this.modalVisible = true;
            })
            .finally(() => {
                this.loading = false;
            });
    },
    beforeMount() {
        if (this.userSegmentPermission) {
            return router.push("/denied");
        }
    },
};
</script>

<style lang="scss">
.user-segments {
    .ant-card {
        border: none;
    }
    .segment-main-title {
        max-width: fit-content;
    }

    .ant-table table {
        width: 100% !important;
        text-align: left !important;
        border-radius: 4px 4px 0 0 !important;
        border-collapse: separate !important;
        border-spacing: 0 !important;
    }

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
        padding: 16px 16px !important;
        overflow-wrap: break-word !important;
    }

    .ant-table-tbody > tr > td {
        padding: 16px 16px !important;
        border-bottom: 1px solid #e8e8e8 !important;
        -webkit-transition: background 0.3s !important;
        transition: background 0.3s !important;
    }

    .ant-table-row-cell-break-word {
        word-wrap: break-word !important;
        word-break: break-word !important;
    }

    .ant-table {
        -webkit-box-sizing: border-box !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        color: rgba(0, 0, 0, 0.65) !important;
        font-size: 14px !important;
        font-variant: tabular-nums !important;
        line-height: 1.5 !important;
        list-style: none !important;
        -webkit-font-feature-settings: "tnum" !important;
        font-feature-settings: "tnum" !important;
        position: relative !important;
        clear: both !important;
    }

    .ant-card {
        -webkit-box-sizing: border-box !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        color: rgba(0, 0, 0, 0.65) !important;
        font-size: 14px !important;
        font-variant: tabular-nums !important;
        line-height: 1.5 !important;
        list-style: none !important;
        -webkit-font-feature-settings: "tnum" !important;
        font-feature-settings: "tnum" !important;
        position: relative !important;
        background: #fff !important;
        border-radius: 2px !important;
        -webkit-transition: all 0.3s !important;
        transition: all 0.3s !important;
    }

    .ant-table-body {
        ant-table-thead {
            margin-bottom: 10px !important;
        }

        tr {
            padding: 16px 16px !important;
            overflow-wrap: break-word !important;
        }

        td {
            font-family: Poppins !important;
            font-size: 12px !important;
            font-weight: 400 !important;
            color: #181c32 !important;
            border-bottom: none !important;
            padding: 16px 16px !important;
            overflow-wrap: break-word !important;
        }

        th {
            border-right: unset !important;
            border-bottom: 1px solid #e8e8e8 !important;
            padding: 0px 16px !important;
            overflow-wrap: break-word;

            &:last-child {
                border-right: unset !important;
            }
        }
    }

    .ant-table-body tbody td {
        border-right: unset !important;
        padding: 16px 16px !important;

        &:last-child {
            border-right: unset !important;
        }
    }
}

//.new-theme .ant-table-body td {
//    padding: 16px 16px !important;
//}
</style>
<style lang="scss">
.user-segments {
    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        width: max-content !important;
    }

    .ant-table-thead > tr > th {
        background: #ffffff;
    }

    .operation-buttons {
        max-width: 0px;
        cursor: pointer;

        &.hidden {
            .operation-button {
                display: none;
            }
        }
    }

    .user-segment-avatar {
        display: flex;
        align-items: center;
        font-size: 16px;
        background: #6899c1;
        border-radius: 50%;
        height: 35px;
        width: 35px;
    }

    .user-segment-avatar-odd {
        display: flex;
        align-items: center;
        font-size: 16px;
        background: #c980a3;
        border-radius: 50%;
        height: 35px;
        width: 35px;
    }
}
</style>
